/**
 * Registers the service worker in production web builds (not in dev, and not inside native
 * Capacitor/Electron shells, which bundle their assets locally).
 */
export function registerServiceWorker(): void {
  // A portal serves the game itself (from its CDN, in an iframe): an offline shell and its own cache would only fight it.
  if (import.meta.env.DEV || !('serviceWorker' in navigator) || import.meta.env.VITE_PORTAL) return;
  const w = window as unknown as { Capacitor?: { isNativePlatform?: () => boolean }; electron?: unknown };
  if (w.Capacitor?.isNativePlatform?.() || w.electron) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* offline caching is optional */
    });
  });
}
